export const getEditSuccess = (name: string): string =>
  `Пользователь "${name}" обновлен`;
export const getEditError = (name: string): string =>
  `Не удалось обновить пользователя "${name}"`;
